<template>
<div>
    <Breadcrumbs main="Admin" submain="Subscription" title="User" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <!-- <div class="card-header">
                        <div style="max-width: fit-content;">
                            <router-link to="/subscriber/add">
                                <button class="btn btn-primary" type="submit" style="display: flex; gap: 12px; align-items: center;">
                                    <i class="fa fa-light fa-plus"></i>
                                    <h7>Add New subscriber</h7>
                                </button>
                            </router-link>
                        </div>
                    </div> -->

                    <div class="card-body">
                        <b-row class="d-flex justify-content-center align-items-center">
                            <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                <b-input-group style="width: 340px;">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>

                                <!-- <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #262062; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="toggleFilterShow()">
                                    <feather type="filter"></feather>
                                    <h7>Filter</h7>
                                </div>

                                <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="filterShow || subscriptionType">
                                    <feather type="x"></feather>
                                    <h7>Clear All</h7>
                                </div> -->
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <!-- <div class="row mt-2" v-if="filterShow || subscriptionType">
                            <div class="col-md-4">
                                <div class="grid-container mt-sm-0">
                                    <div class="grid-item">
                                        <span style="margin-bottom: 4px;">Subscription Type</span>
                                        <b-form-select v-model="subscriptionType" :options="formattedSubscription"></b-form-select>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <div v-if="!loading && !error && !loadingPage">
                            <div class="table-responsive datatable-vue mt-4">
                                <b-table :items="subscriber_list" :fields="tablefields" :per-page="perPage" :filter="filter" show-empty stacked="md">

                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(user_object)="row">
                                        <div style="display: flex; flex-direction: column; gap: 4px;">
                                            <h7>{{ row.item.user_object?.first_name }} {{ row.item.user_object?.last_name }}</h7>
                                            <b-badge style="font-size: 13px; max-width: fit-content;">{{ row.item.user_object?.email }}</b-badge>
                                        </div>
                                    </template>

                                    <template #cell(profile_id)="row">
                                        <h7>{{ row.item.personal_info?.profile_id }}</h7>
                                    </template>

                                    <template #cell(phone_no)="row">
                                        <h7>{{ row.item.personal_info?.phone_number }}</h7>
                                    </template>

                                    <template #cell(registration_date)="row">
                                        <h7 v-if="row.item.personal_info">{{ formatDate(row.item.personal_info?.first_registration_date).date }} <br> {{ formatDate(row.item.personal_info?.first_registration_date).time }}</h7>
                                    </template>

                                    <template #cell(action)="data">
                                        <div>
                                            <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteUser(data.item?.user_object?.id)" title="Delete"></feather>
                                        </div>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <!-- <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col> -->
                        <b-row class="mt-3">
                            <b-col xl="12" class="d-flex flex-wrap justify-content-start align-items-center" style="gap: 8px;">
                                <span>
                                    <!-- First Page Button (<<) -->
                                    <button class="pg-button" :disabled="currentPage === 1" @click="goToPage(1)">
                                        <b-icon icon="chevron-double-left"></b-icon>
                                    </button>
    
                                    <!-- Previous Page Button (<) -->
    
                                    <button class="pg-button ml-2" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
                                        <b-icon icon="chevron-left"></b-icon>
                                    </button>
                                </span>

                                <!-- Page Number Display (Page X of Y) -->
                                <span class="align-self-center">
                                    <span class="align-self-center">
                                        <span class="d-flex align-items-center" style="gap: 6px;">
                                            <span>Page</span>
                                            <b-form-input v-model="currentPage" style="box-shadow: none; max-width: 40px;" @blur="validatePage" @keydown.enter="validatePage" :disabled="totalPages <= 1"></b-form-input>
                                            <span>of {{ totalPages }}</span>
                                        </span>
                                    </span>
                                </span>

                                <span>
                                    <!-- Next Page Button (>) -->
                                    <button class="mr-2 pg-button" :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">
                                        <b-icon icon="chevron-right"></b-icon>
                                    </button>
    
                                    <!-- Last Page Button (>>) -->
                                    <button class="pg-button" :disabled="currentPage === totalPages" @click="goToPage(totalPages)">
                                        <b-icon icon="chevron-double-right"></b-icon>
                                    </button>
                                </span>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- User Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this user?</div>
    </b-modal>
</div>
</template>

<script>
import { mapState } from 'vuex';
import { myHost } from '../../../_helpers/host';
import loader from '../loader/loader.vue';
import Multiselect from 'vue-multiselect';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader,
        Multiselect
    },

    data() {
        return {
            host: myHost.host,
            selected: [],
            isDisabled: false,
            subscriber: {

            },
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'user_object',
                    label: 'Subscriber',
                    sortable: true
                },
                {
                    key: 'phone_no',
                    label: 'Phone No',
                    sortable: true
                },
                {
                    key: 'profile_id',
                    label: 'Profile ID',
                    sortable: true
                },
                {
                    key: 'registration_date',
                    label: 'Registered On',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            delete_value: null,
            initialLoad: true,
            filterShow: false,
            subscriptionType: null,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            loadingPage: false,
            pageOptions: [25, 50, 100]
        };
    },

    computed: {
        ...mapState({
            subscription_types: state => state.packages.package,
            subscriber_list: state => state.subscriber.subscriber,
            loading: state => state.subscriber.subscriberLoading,
            error: state => state.subscriber.subscriberError,
            count: state => state.subscriber.subscriber_count
        }),

        formattedSubscription() {
            return [{
                    value: null,
                    text: 'Select a subscription type',
                    disabled: true
                },
                ...this.subscription_types.map(type => ({
                    value: type.id,
                    text: type.title + " (" + type.type + ")"
                }))
            ];
        },

        totalPages() {
            if (typeof this.totalRows === 'number' && !isNaN(this.totalRows) && this.totalRows > 0) {
                return Math.ceil(this.totalRows / this.perPage);
            }
            return 1; // Default to 1 if totalRows is invalid
        }
    },

    watch: {
        subscriptionType(newVal, oldVal) {
            if (!this.initialLoad) {
                if (this.subscriptionType != null) {
                    this.$router.replace({
                        path: '/subscription/user/list',
                        query: {
                            page: this.currentPage,
                            perPage: this.perPage,
                            subscriptionType: newVal
                        }
                    });
                } else {
                    this.$router.replace({
                        path: '/subscription/user/list',
                        query: {
                            page: this.currentPage,
                            perPage: this.perPage
                        }
                    });
                }
                this.$store.dispatch("subscriber/fetchSubscriber", {
                    perPage: this.perPage,
                    currentPage: 1,
                    subscriptionType: newVal
                }).then(() => {
                    this.currentPage = 1
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        },

        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                if (this.currentPage === null || this.currentPage === '') {
                    this.loadingPage = true
                }
                if (this.subscriptionType != null) {
                    this.$router.replace({
                        path: '/subscription/user/list',
                        query: {
                            page: newCurrentPage,
                            perPage: this.perPage,
                            subscriptionType: this.subscriptionType
                        }
                    });
                } else if (this.subscriptionType == null) {
                    this.$router.replace({
                        path: '/subscription/user/list',
                        query: {
                            page: newCurrentPage,
                            perPage: this.perPage
                        }
                    });
                } else {
                    this.$router.replace({
                        path: '/subscription/user/list',
                        query: {
                            page: newCurrentPage,
                            perPage: this.perPage
                        }
                    });
                }

                this.currentPage = newCurrentPage
                this.$store.dispatch("subscriber/fetchSubscriber", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage,
                    subscriptionType: this.subscriptionType
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                if (this.subscriptionType != null) {
                    this.$router.replace({
                        path: '/subscription/user/list',
                        query: {
                            page: this.currentPage,
                            perPage: newperPage,
                            subscriptionType: this.subscriptionType
                        }
                    });
                } else if (this.subscriptionType == null) {
                    this.$router.replace({
                        path: '/subscription/user/list',
                        query: {
                            page: this.currentPage,
                            perPage: newperPage
                        }
                    });
                } else {
                    this.$router.replace({
                        path: '/subscription/user/list',
                        query: {
                            page: this.currentPage,
                            perPage: newperPage
                        }
                    });
                }

                this.perPage = newperPage
                this.$store.dispatch("subscriber/fetchSubscriber", {
                    perPage: newperPage,
                    currentPage: this.currentPage,
                    subscriptionType: this.subscriptionType
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        }
    },

    created() {
        this.$store.dispatch("packages/fetchPackage")
    },

    mounted() {
        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
                this.fetchInitial();
            } else {
                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);
                this.subscriptionType = parseInt(this.$route.query.subscriptionType);
                this.fetchInitial();
            }
        }
    },

    methods: {
        validatePage() {
            this.loadingPage = true;
            const totalPages = this.totalPages;
            
            if (!this.currentPage || isNaN(this.currentPage) || this.currentPage < 1) {
                this.currentPage = 1;
            } else if (Number(this.currentPage) > totalPages) {
                this.currentPage = totalPages; // Set to last valid page
            }

            this.loadingPage = false;
        },

        goToPage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
        },

        formatDate(dateStr) {
            if (!dateStr) return ''

            const date = new Date(dateStr)

            const day = date.getDate()
            const month = date.toLocaleString('default', {
                month: 'long'
            })
            const year = date.getFullYear()

            const hours = date.getHours()
            const minutes = date.getMinutes().toString().padStart(2, '0')
            const ampm = hours >= 12 ? 'PM' : 'AM'
            const hour12 = hours % 12 || 12

            const getOrdinal = (n) => {
                const s = ['th', 'st', 'nd', 'rd']
                const v = n % 100
                return s[(v - 20) % 10] || s[v] || s[0]
            }

            return {
                date: `${day}${getOrdinal(day)} ${month}, ${year}`,
                time: `${hour12}:${minutes} ${ampm}`
            }
        },

        fetchInitial() {
            this.$store.dispatch("subscriber/fetchSubscriber", {
                perPage: this.$route.query.perPage,
                currentPage: this.$route.query.page,
                subscriptionType: this.$route.query.subscriptionType
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        // getDetail(subscriberDetail) {
        //     this.subscriber.home_address.address_shelter = subscriberDetail.home_address.address_shelter
        //     this.subscriber.home_address.address_union = subscriberDetail.home_address.address_union
        //     this.subscriber.home_address.address_upozila = subscriberDetail.home_address.address_upozila
        //     this.subscriber.home.home_distance_from_shelter = subscriberDetail.home.home_distance_from_shelter
        //     this.subscriber.home.road_condition = subscriberDetail.home.road_condition
        //     this.subscriber.home.home_image = subscriberDetail.home.home_image
        // },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        clearFilter() {
            this.filterShow = false,
                this.subscriptionType = null,
                this.$router.replace({
                    path: '/subscription/user/list',
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                });
            this.fetchInitial();
        },

        toggleFilterShow() {
            this.filterShow = !this.filterShow
        },

        deleteUser(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("subscriber/deleteSubscriber", {
                delete: this.delete_value,
                perPage: this.$route.query.perPage,
                currentPage: this.$route.query.page
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.message,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>

<style scoped>
.table-danger {
    background-color: #f8d7da !important;
    color: #721c24 !important;
}
</style>
